<div class="row">
    <div class="col-12 text-center">
      <div class="error-gif">
        <img src="assets/gif/error.gif" class="error-gif-image" alt="close" />
        <!-- <p class="text-orange gif-icon-text">Lorem Ipsum</p> -->
      </div>
    </div>
    <div class="col-12">
      <h5 class="text-center">Refresh the page</h5>
    </div>
    <div class="col-12 d-flex justify-content-center">
      <div class="me-1">
        <p class="text-content text-center">
         Some details may have been updated. Allow us to fetch the latest information when you refresh the page
        </p>
      </div>
    </div>
   
  </div>
  <div class="row">
    <div class="d-flex justify-content-center">
        <button
          class="submit-btn success-submission"
          (click)="reload()"
          type="submit"
        >
          Refresh the page
        </button>
      </div>
  </div>